// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import Button from 'components/common/Button';
import AdminSection from 'components/common/AdminSection';
import AdminDataRow from 'components/common/AdminDataRow';
import OrganizationForm from 'components/forms/OrganizationForm';
import AddTeamMemberForm from 'components/forms/AddTeamMemberForm';
import AddCustomDashboardForm from 'components/forms/AddCustomDashboardForm';
import MsaForm from 'components/forms/MsaForm';
import BackButton from 'components/common/BackButton';
import TeamList from './TeamList';
import MsaList from './MsaList';
import DashboardList from './DashboardList';
// ANTD
import Popconfirm from 'antd/lib/popconfirm';
import 'antd/lib/popconfirm/style/css';
// APOLLO
import organizationByIdQuery from 'ApolloClient/Queries/organizationById';
import deleteOrganization from 'ApolloClient/Mutations/deleteOrganization';
import addUserToTeam from 'ApolloClient/Mutations/addUserToTeam';
import addDashboardToOrg from 'ApolloClient/Mutations/addDashboardToOrg';
import saveOrganzation from 'ApolloClient/Mutations/saveOrganzation';
import editMsas from 'ApolloClient/Mutations/editMsas';
import { graphql, compose } from 'react-apollo';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
import message from 'antd/lib/message';
import formatTableDate from '../../lib/helpers/GeneralHelpers/formatTableDate';
import getUsersFullName from '../../lib/helpers/GeneralHelpers/getUsersFullName';
import ErrorHelpers from '../../lib/helpers/ErrorHelpers/index';

const CantFindOrg = ({ onClick }) => {
  return (
    <PageContainer>
      We can not find this organization....{' '}
      <a href="#" onClick={onClick}>
        Go Back
      </a>
    </PageContainer>
  );
};

class AdminOrganizationDetail extends React.PureComponent {
  state = {
    editGeneralInfo: false,
    editMsaInfo: false,
    editTeamMembers: false,
    editDashboards: false,
  };

  onDeleteOrganization = async () => {
    const organization = this.props.organizationByIdQuery.organizationById;
    let res;
    try {
      res = await this.props.deleteOrganization({
        variables: {
          orgId: organization._id,
        },
      });
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }
    message.success('organization deleted!');
    this.props.history.push('/admin/organizations');
    window.location.reload();
  };

  handleSaveOrganization = async (values) => {
    const organization = this.props.organizationByIdQuery.organizationById;

    let variables = {
      orgId: organization._id,
      params: {
        ...values,
      }
    };

    try {
      await this.props.saveOrganzation({ variables });
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }

    message.success('Organization successfully saved!');
    window.location.reload();
  };

  handleAddTeamMemberFormSubmit = async userId => {
    const organization = this.props.organizationByIdQuery.organizationById;
    let variables = {
      orgId: organization._id,
      userId,
    };

    try {
      await this.props.addUserToTeam({ variables });
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }

    message.success('Team member successfully added!');
    window.location.reload();
  };

  handleAddDashboardToOrg = async dashboardId => {
    const organization = this.props.organizationByIdQuery.organizationById;
    let res;
    let variables = {
      orgId: organization._id,
      dashboardId,
    };

    try {
      res = await this.props.addDashboardToOrg({ variables });
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }

    message.success('Dashboard successfully added!');
    window.location.reload();
  };

  handleMsaFormSubmit= async (values)=> {
    const organization = this.props.organizationByIdQuery.organizationById;
    let variables = {
      orgId: organization._id,
      params: {
        ...values
      }
    }

    try {
      await this.props.editMsas({ variables })
    }
    catch(err){
      return console.log(err)
    }
    this.setState({ editMsaInfo: !this.state.editMsaInfo });
    message.success('MSA info successfully saved!');
    window.location.reload();
  }

  render() {
    // grab the organization off the query
    const organization = this.props.organizationByIdQuery.organizationById;

    // check to see if organization exists
    if (!organization) {
      return <CantFindOrg onClick={this.props.history.goBack} />;
    }

    return (
      <div>
        <BackButton />
        <PageContainer>
          <React.Fragment>
            <AdminSection
              label={organization.title}
              onEditText={!this.state.editGeneralInfo ? 'edit' : 'cancel'}
              onEdit={() => this.setState({ editGeneralInfo: !this.state.editGeneralInfo })}
            >
              {!this.state.editGeneralInfo ? (
                <React.Fragment>
                  <AdminDataRow label="ID">{organization._id}</AdminDataRow>
                  <AdminDataRow label="Name">{organization.title}</AdminDataRow>
                  <AdminDataRow label="Date Started">{formatTableDate(organization.createdAt)}</AdminDataRow>
                  <AdminDataRow label="Main User">{getUsersFullName(organization.mainUser)}</AdminDataRow>
                  <AdminDataRow label="Subscribed">{`${organization.subscribed}`}</AdminDataRow>
                </React.Fragment>
              ) : (
                <OrganizationForm
                  handleSubmit={this.handleSaveOrganization}
                  organization={organization}
                  buttonLabel="Save Changes"
                />
              )}
            </AdminSection>
            <AdminSection
              label="Dashboards"
              onEditText={!this.state.editDashboards ? '+ Dashboard' : 'cancel'}
              onEdit={() => this.setState({ editDashboards: !this.state.editDashboards })}
            >
              {!this.state.editDashboards ? (
                <DashboardList dashboards={organization.dashboards} organization={organization} />
              ) : (
                <div>
                <AddCustomDashboardForm handleSubmit={this.handleAddDashboardToOrg} />
                <DashboardList dashboards={organization.dashboards} organization={organization} />
                </div>
              )}
            </AdminSection>
            <AdminSection
              label="Team"
              onEditText={!this.state.editTeamMembers ? '+ User' : 'cancel'}
              onEdit={() => this.setState({ editTeamMembers: !this.state.editTeamMembers })}
            >
              {!this.state.editTeamMembers ? (
                <TeamList users={organization.teamMembers} organization={organization} />
              ) : (
                <div>
                  <AddTeamMemberForm handleSubmit={this.handleAddTeamMemberFormSubmit} />
                  <TeamList users={organization.teamMembers} organization={organization} />
                </div>
              )}
            </AdminSection>
            <AdminSection
              label={`MSAs (${organization.numberOfMSAs})`}
              onEditText={!this.state.editMsaInfo ? 'edit' : 'cancel'}
              onEdit={() => this.setState({ editMsaInfo: !this.state.editMsaInfo })}
            >
              {this.state.editMsaInfo ? (
                <MsaForm
                  allowedStates={organization.allowedStates}
                  allowedMSAs={organization.allowedMSAs}
                  msaMode={organization.msaMode}
                  organization={organization}
                  handleSubmit={this.handleMsaFormSubmit}
                />
              ) : <MsaList organization={organization} />}
            </AdminSection>
            <AdminSection label="DANGER ZONE">
              <Popconfirm
                placement="topLeft"
                title="Are you sure?"
                onConfirm={this.onDeleteOrganization}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger">Delete Organization</Button>
              </Popconfirm>
            </AdminSection>
          </React.Fragment>
        </PageContainer>
      </div>
    );
  }
}

let options = props => ({
  variables: {
    orgId: props.match.params.orgId,
  },
});

export default compose(
  graphql(organizationByIdQuery, { options, name: 'organizationByIdQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'organizationByIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'organizationByIdQuery' }),
  graphql(deleteOrganization, { name: 'deleteOrganization' }),
  graphql(addUserToTeam, { name: 'addUserToTeam' }),
  graphql(editMsas, { name: 'editMsas' }),
  graphql(addDashboardToOrg, { name: 'addDashboardToOrg' }),
  graphql(saveOrganzation, { name: 'saveOrganzation' }),
)(AdminOrganizationDetail);



// WEBPACK FOOTER //
// ./src/routes/admin-organization-detail/index.js